<!-- Accordion variant filter wrapper - avf -->
<div class="one3d-avf-wrapper" *ngIf="this.showFilter">
  <!--filter Block-->

  <div class="one3d-avf insiteFilterBlock">
    <!--title-->
    <button (click)="showHideFilters()" class="filtertitle filterAct">
      {{ "VARIANTS.FILTERS" | translate }}
      <div class="downArow">
        <img src="assets/img/icons/co-down-arow-icon.svg" alt="" />
      </div>
    </button>
    <!--title-->
    <!--info-->
    <div
      class="filtertitleinfo"
      [ngClass]="{ 'one3d-display-none': !filtersVisible }"
      id="hideinfo"
    >
      <div *ngFor="let filter of variantsFilters" class="filtertitleinfoinner">
        <!--Row 1-->
        <div class="filterList">
          <!--row title-->
          <div class="filterListtitle">
            {{ filter.filterName }}
          </div>
          <!--row title-->
          <!--right radio btn-->
          <div class="filterListradio">
            <!--loop-->
            <div
              *ngFor="let item of filter.filterValues; let i = index"
              class="filterListin"
              [ngClass]="{
                disabled:
                  filter.filterName == 'Drive' && transmissionType == '6MT'
              }"
            >
              <div class="coradio mngRadio">
                <input
                  [id]="item"
                  type="radio"
                  [name]="filter.filterName"
                  value=""
                  [checked]="
                    filter.filterName == 'Drive'
                      ? driveType == item
                      : filter.filterName == 'Transmission'
                      ? transmissionType == item
                      : filter.filterName == 'Fuel'
                      ? fuelType == item
                      : filter.filterName == 'Seat'
                      ? seatType == item
                      : ''
                  "
                  [disabled]="disableFilters"
                  (change)="filterVariants(filter.filterName, $event)"
                />
                <label [for]="item" style="text-transform: capitalize">{{
                  item
                }}</label>
              </div>
            </div>
            <!--loop-->
          </div>
          <!--right radio btn-->
        </div>
        <!--Row 1-->
      </div>
    </div>
    <!--info-->
  </div>

  <!--filter Block-->
</div>

<!-- Accordion variant list wrapper - avf -->
<div class="one3d-avl-wrapper">
  <ion-accordion-group class="ion-hide-lg-down">
    <ion-accordion
      toggleIcon="add"
      *ngFor="let variant of variantsForUi; let i = index"
      class="one3d-acc-variants"
    >
      <ion-item class="one3d-avl-item ion-no-padding" slot="header">
        <ion-grid fixed>
          <ion-row>
            <ion-col size="2" (click)="selectVariantCheck(variant)">
              <ion-checkbox
                [checked]="variant.variant_id == selectedVariant.variant_id"
                mode="ios"
                style="pointer-events: none"
                aria-label="variant-list"
              ></ion-checkbox>
            </ion-col>
            <ion-col
              size="10"
              (click)="toggleAccordionClick(variant.variant_name, i)"
            >
              <ion-label class="one3d-avl-label">
                <h4 class="one3d-avl-variant-name one3d-avl-variant-name-right">
                  {{ variant.variant_name | uppercase }}
                </h4>
                <p class="one3d-avl-variant-price">
                  {{
                    variant.variant_id == selectedVariant.variant_id
                      ? globalService.currencyFormatter(
                          globalService.selectedConfigPrice?.drive_away_price
                        )
                      : globalService.currencyFormatter(
                          variant.color[0]?.total_price
                        )
                  }}
                  <span class="one3d-avl-showroom-span"
                    >{{ "VARIANTS.DRIVE_AWAY_PRICE" | translate }}*</span
                  >
                </p>
                <p
                  class="one3d-avl-variant-price one3d-avl-variant-price-pack"
                  *ngIf="checkIfDefaultPackLoaded(variant)"
                >
                  ^Add-on {{ globalService.model?.model_name }}
                  {{ defaultPackLoadedDetails(variant, "name") }} available at
                  {{ globalService.currencySymbol }}
                  {{ defaultPackLoadedDetails(variant, "price") }}
                </p>
                <!--one3d-variants-icon-->
                <div class="one3d-variants-icon">
                  <!--row-->
                  <div class="one3d-variants-icon-list">
                    <div class="one3d-variants-icon-list-row">
                      <div class="one3d-variants-icon-title">
                        <img
                          src="assets/img/icons/variants-fuel-icon.svg"
                          alt="icon"
                        />
                      </div>
                      <div class="one3d-variants-icon-subtitle">
                        {{ variant.fuel_type }}
                      </div>
                    </div>
                  </div>
                  <!--row-->
                  <!--row-->
                  <div class="one3d-variants-icon-list">
                    <div class="one3d-variants-icon-list-row">
                      <div class="one3d-variants-icon-title">
                        <img
                          src="assets/img/icons/variants-drive-icon.svg"
                          alt="icon"
                        />
                      </div>
                      <div class="one3d-variants-icon-subtitle">
                        {{ variant.drive }}
                      </div>
                    </div>
                  </div>
                  <!--row-->
                  <!--row-->
                  <div class="one3d-variants-icon-list">
                    <div class="one3d-variants-icon-list-row">
                      <div class="one3d-variants-icon-title">
                        <img
                          src="assets/img/icons/variants-transmission-icon.svg"
                          alt="icon"
                        />
                      </div>
                      <div class="one3d-variants-icon-subtitle">
                        {{ variant.transmission_code }}
                      </div>
                    </div>
                  </div>
                  <!--row-->
                </div>
                <!--one3d-variants-icon-->
              </ion-label>
            </ion-col>
          </ion-row>
        </ion-grid>
        <span
          (click)="toggleAccordionClick(variant.variant_name, i)"
          class="ion-accordion-toggle-icon ion-accordion-toggle-icon-top"
        ></span>
      </ion-item>
      <!--new disclaimer-->
      <ion-list class="ion-no-padding" slot="content">
        <ion-grid class="ion-no-padding" fixed>
          <ion-row class="one3d-key-features-padding one3d-key-features-info">
            <ion-col class="ion-no-padding" size="12">
              <!-- <h6 *ngIf="variant.packages && variant.packages.length > 0">
                This pack includes:
                <ul *ngFor="let package of variant.packages">
                  <li *ngFor="let accessory of package.accessoriesList">
                    {{ accessory.marketing_name }}
                  </li>
                </ul>
              </h6> -->
              <p *ngIf="variant.variant_desc">
                {{
                  showMore
                    ? variant.variant_desc
                    : (variant.variant_desc | slice : 0 : 100)
                }}
                <span (click)="showMore = !showMore">
                  {{ showMore ? "Show less" : "Show More" }}
                </span>
              </p>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-list>
      <!--new disclaimer-->

      <!-- <ion-list class="ion-no-padding" slot="content">
        <ion-grid class="ion-no-padding" fixed>
          <ion-row class="one3d-key-features-padding">
            <ion-col class="ion-no-padding" size="2"></ion-col>
            <ion-col class="ion-no-padding" size="10">
              <ion-label class="one3d-avl-features-label" translate>
                VARIANTS.KEY_FEATURES
              </ion-label>
              <ul class="one3d-avl-features">
                <li
                  *ngFor="let feature of variant.features"
                  class="one3d-avl-features-list"
                >
                  {{ feature.feature_name }}
                </li>
              </ul>
            </ion-col>
          </ion-row> 
        </ion-grid>
      </ion-list> -->
    </ion-accordion>
    <p
      *ngIf="variantsForUi?.length == 0"
      class="one3d-no-variants-found"
      translate
    >
      VARIANTS.NO_VARIANTS_FOUND
    </p>
  </ion-accordion-group>
  <div
    *ngFor="let variant of variantsForUi"
    class="one3d-avl-mobile-wrapper ion-hide-lg-up"
  >
    <ion-row>
      <ion-col
        class="one3d-avl-item-mobile"
        size="11"
        (click)="selectVariantCheck(variant)"
      >
        <ion-checkbox
          [checked]="variant.variant_id == selectedVariant.variant_id"
          mode="ios"
          style="pointer-events: none"
          aria-label="select-variant"
        ></ion-checkbox>
        <ion-label class="one3d-avl-label" style="width: 100%">
          <h4 class="one3d-avl-variant-name">
            {{ variant.variant_name | uppercase }}
          </h4>
          <p class="one3d-avl-variant-price">
            {{
              variant.variant_id == selectedVariant.variant_id
                ? globalService.currencyFormatter(
                    globalService.selectedConfigPrice?.drive_away_price
                  )
                : globalService.currencyFormatter(variant.color[0]?.total_price)
            }}
            <span class="one3d-avl-showroom-span"
              >{{ "VARIANTS.DRIVE_AWAY_PRICE" | translate }}*</span
            >
          </p>
          <p
            class="one3d-avl-variant-price one3d-avl-variant-price-pack"
            *ngIf="checkIfDefaultPackLoaded(variant)"
          >
            ^Add-on {{ globalService.model?.model_name }}
            {{ defaultPackLoadedDetails(variant, "name") }} available at
            {{ globalService.currencySymbol }}
            {{ defaultPackLoadedDetails(variant, "price") }}
          </p>
          <!--one3d-variants-icon-->
          <div class="one3d-variants-icon">
            <!--row-->
            <div class="one3d-variants-icon-list">
              <div class="one3d-variants-icon-list-row">
                <div class="one3d-variants-icon-title">
                  <img
                    src="assets/img/icons/variants-fuel-icon.svg"
                    alt="icon"
                  />
                </div>
                <div class="one3d-variants-icon-subtitle">
                  {{ variant.fuel_type }}
                </div>
              </div>
            </div>
            <!--row-->
            <!--row-->
            <div class="one3d-variants-icon-list">
              <div class="one3d-variants-icon-list-row">
                <div class="one3d-variants-icon-title">
                  <img
                    src="assets/img/icons/variants-drive-icon.svg"
                    alt="icon"
                  />
                </div>
                <div class="one3d-variants-icon-subtitle">
                  {{ variant.drive }}
                </div>
              </div>
            </div>
            <!--row-->
            <!--row-->
            <div class="one3d-variants-icon-list">
              <div class="one3d-variants-icon-list-row">
                <div class="one3d-variants-icon-title">
                  <img
                    src="assets/img/icons/variants-transmission-icon.svg"
                    alt="icon"
                  />
                </div>
                <div class="one3d-variants-icon-subtitle">
                  {{ variant.transmission_code }}
                </div>
              </div>
            </div>
            <!--row-->
          </div>
          <!--one3d-variants-icon-->
        </ion-label>
      </ion-col>
      <ion-col
        class="one3d-avl-item-mobile-icon"
        size="1"
        (click)="showKeyFeatures(variant)"
      >
        <img
          src="assets/img/icons/one3d-info-icon.svg"
          alt="information-icon"
        />
      </ion-col>
    </ion-row>
  </div>
</div>
